import React from 'react'

export default function FooterComponent() {
  return (
    <div id='helloTradeFooter' className='helloTradeFooter' style={{padding:'0px'}}>
      

      {/* <div id='footerInfo' className='footerInfo'>
        <div className='footerSection '>
          <h4 style={{opacity:'0.7'}}>Grievance Redressal Officer Details:</h4>
          <p>Name</p>
          <p>Name</p> 
          <p><i class="bi bi-telephone"></i><span style={{margin:'8px'}}>Mob No</span></p>
          <p>RBI's Sachet Portal</p> 
          <p><i class="bi bi-envelope"></i><span style={{margin:'8px'}}>Email</span></p>
        </div>
        
        <div className='footerSection '>
          <h4 style={{opacity:'0.7'}}>Address:</h4>
          <p>6th Floor, Tower 2, Assotech Business Cresterra, Plot No. 22, Sector-135, Noida - 201305.</p>
          <p>+91-9876543210</p>
          <p>abc@gmail.com</p>
          <p>Customer Care Working Hours:</p>
          <p>Monday through Friday, 10:00 A.M. to 6:00 P.M.</p>
        </div>
        
        <div id='disclaimer' className='footerSection '>
          <h4 style={{opacity:'0.7'}}>Disclaimer</h4>
          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
          <a href="#" className="dmcaBadge"><img src={dmca} alt="DMCA Protected" style={{width:'82px',height:'41px'}}/></a>
        </div>
      </div> */}

      {/* <hr></hr> */}

      <div className='nav' style={{padding:'10px'}}>
        <div className='allNavs'>
          <span onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{cursor:'pointer'}}>About Us</span>
          <span onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{cursor:'pointer'}}>Privacy Policy</span>
          <span onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{cursor:'pointer'}}>Terms</span>
        </div>

        <div id='copyright'>
        © 2025 IIL Digital Private Limited. All rights reserved.
        </div>
        
      </div>
      
    </div>

  )
}
